import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class LabelPlacementReferenceService extends BaseReferenceService {
  constructor() {
    super('LabelPlacementReference');
  }
}
